module.exports = __webpack_public_path__ + "img/blue_153.a6fb28ab.png";